define(['morningstar'], function(morningstar) {
    'use strict';
    morningstar.asterix.ng.transforms.register('fromPAAPIHypoToGrowthTable', function(securities) {
        var rows = [];
        if (!securities._$isLoading && securities.originalData) {
            var hypoData = securities.originalData.Hypo || [],
                chartSettings = this.context.instance.model.chartSettings;
            rows = generateHypotheticalGrowthTableModel(hypoData, chartSettings);
        }
        return rows;
    });

    function generateHypotheticalGrowthTableModel(hypoData, chartSettings) {
        var tableData = [],
            subsequentInvestmentType = chartSettings.investmentType.key.toLowerCase(),
            initialInvestmentAmount = chartSettings.initialInvestmentAmount;
        morningstar.asterix.util.each(hypoData, function(item) {
            var totalWithdrawal = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalDistributionAndWithdrawal')(item) || 0,
                totalNewInvestment = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalNewInvestment')(item) || initialInvestmentAmount,
                finalMarketValue = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.FinalMarketValue')(item) || 0,
                totalContributionAmounts = totalNewInvestment,
                totalGain = 0;
            if (subsequentInvestmentType === 'withdrawal') {
                totalGain = finalMarketValue - initialInvestmentAmount + totalWithdrawal;
            } else {
                totalGain = finalMarketValue - totalNewInvestment;
            }
            var earliestInceptionDate = morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(item);
            tableData.push({
                name: item.PortfolioName,
                asOfDate: morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(item) || '',
                totalContributionAmounts: totalContributionAmounts,
                marketValue: finalMarketValue,
                totalGain: totalGain,
                cumulativeReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.CumulativeReturn')(item) || 0,
                avgAnnualizedReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.AverageAnnualizedReturn')(item) || 0,
                inceptionDate: earliestInceptionDate ? morningstar.asterix.util.date.convertToStandard(new Date(earliestInceptionDate)) : ''
            });
        });
        return tableData;
    }
});


// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/transforms/from-pa-api-hypo-to-growth-table.js